import { createStore } from 'vuex'
import app from './app'
import routeRecord from './routeRecord'
import user from './user'
import subscription from './subscription'
import home from './home'
import gupStatistics from './gupStatistics'
import gupbridge from './gupbridge'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    routeRecord,
    user,
    subscription,
    home,
    gupStatistics,
    gupbridge,
  },
})
